<template>
  <gmap-marker
    :position="position"
    :animation="animation"
    :icon="icon"
    :draggable="true"
    @dragend="updatePosition($event.latLng)"
    @click="toggleBounce"
  >

  </gmap-marker>
</template>

<script>
import bus from "@/api/bus";

export default {
  props: ['position', 'type'],
  computed: {
    icon() {
      if(this.type == 'place')
        return { url: 'https://maps.google.com/mapfiles/ms/icons/green-dot.png' };
      else if (this.type == 'chapter')
        return null; // fazer ícones nossos pra capítulo e grupo
      else
        return null;
    }
  },
  data() {
    return {
      animation: 1
    }
  },
  mounted() {
    bus.emit.position(this.position)
  },
  methods: {
    toggleBounce() {
      this.animation == 1 ? this.animation = 0 : this.animation = 1
    },
    updatePosition(position) {
      bus.emit.position({
        lat: position.lat(),
        lng: position.lng()
      })
    }
  },
}
</script>
